import React, { useState } from 'react';
import { SafeSuspense } from 'utils/SafeSuspense';
import { CloseMapButton } from 'components/navigation/user-mobile-navigation/CloseMapMobileButton';
import Legend, { LegendState } from './Legend';
import * as Styled from './styled';
import MapListToggle from 'screens/DeveloperPage/components/map-list-toggle';
import { ShowAt, useScreenBreakpoint } from 'consts/breakpoints';
import { PoiId } from 'utils/entities';
import { Section } from 'components/navigation/subheader/SectionsNavigation';
import { projectFilterSections } from 'screens/DeveloperPage/helpers';
import { agentOfficeMapLegentInitialStateSelector } from './selectors';
import { State } from 'store/state';
import { connect } from 'react-redux';


const ConnectedMap = React.lazy(() => import('./ConnectedMap'));

interface AgentOfficeMapProps {
  showMobileMap: boolean;
  setShowMobileMap: (val: boolean) => void;
  activeSection: Section;
  hasPaddingBottom: boolean;
  initialLegendState: LegendState;
}

const AgentOfficeMap: React.FC<AgentOfficeMapProps> = ({ showMobileMap, setShowMobileMap, activeSection, hasPaddingBottom, initialLegendState }) => {
  const [ activePoi, setActivePoi ] = useState<PoiId>(null);
  const [ legendState, setLegendState ] = useState<LegendState>(initialLegendState);
  const closeMobileMap = () => {
    setShowMobileMap(false);
    setActivePoi(null);
  };
  const isMobile = useScreenBreakpoint() === 1;
  const hideToggle = isMobile && activePoi || !projectFilterSections.has(activeSection);

  return (
    <>
      <Styled.Wrapper noTopMargin showMobileMap={showMobileMap}>
        <Styled.MapWrapper>
          <link href="https://api.tiles.mapbox.com/mapbox-gl-js/v1.9.1/mapbox-gl.css" rel="stylesheet" />
          <SafeSuspense>
            <ConnectedMap
              activePoi={activePoi}
              setActivePoi={setActivePoi}
              legendState={legendState}
            />
            <Legend legendState={legendState} setLegendState={setLegendState} />
            {showMobileMap ? (
              <CloseMapButton onClose={closeMobileMap} />
            ) : null}
          </SafeSuspense>
        </Styled.MapWrapper>
      </Styled.Wrapper>
      {hideToggle ? null : (
        <ShowAt to={2}>
          <MapListToggle showMap={showMobileMap} setShowMap={setShowMobileMap} hasPaddingBottom={hasPaddingBottom} />
        </ShowAt>
      )}
    </>
  );
};

const mapStateToProps = (state: State) => ({
  initialLegendState: agentOfficeMapLegentInitialStateSelector(state),
});

export default connect(mapStateToProps)(AgentOfficeMap);
